export default "__VITE_ASSET__B5rEO9SW__"